import { AES } from "crypto-js";

// Kunci rahasia yang digunakan untuk enkripsi
const secretKey = "UIPOEHJSLDYRGDJS";

// Fungsi untuk mengenkripsi dan menyimpan data array di local storage
export const encryptArrayLocalStorage = (key, array) => {
  const encryptedValue = AES.encrypt(
    JSON.stringify(array),
    secretKey
  ).toString();
  localStorage.setItem(key, encryptedValue);
};
